
import React, { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router";

const Loading = (Component) => (props) =>
(
    <Suspense fallback={<withLoader />}>
        <Component {...props} />
    </Suspense>
);

const Application = Loading(lazy(() => import("../components/Application")));
const MainPage = Loading(
    lazy(() => import("../components/MainPage"))
);

function RedirectionWrapper({ to }) {
    const queryString = window.location.search;
    if (queryString) {
        return <Navigate to={`${to}${queryString}`} />;
    }
    return <Navigate to={to} />;
}

const routes = () => [
    {
        path: "/",
        element: <Application />,
        children: [
            {

                element: (<RedirectionWrapper to="/:id" />),
                index: true,
            }
        ]
    },
    {
        path: "/:id",
        element: <MainPage isPreview={false}/>,
    },
    {
        path: "/:id/preview",
        element: <MainPage isPreview={true}/>,
    }
];

export default function Routes() {
    return useRoutes(routes());
}
